<template>
  <div class="goods-detail-item">
    <div class="goods-store">
      <a href="javascript:;" @click ="bindGoStoreInfo()">
        <div class="store-row">
          <div class="store-img"><img :src="storeInfo.storeAvatarUrl "></div>
          <div class="store-info">
            <div class="store-name">{{storeInfo.storeName}}</div>
            <!--<div class="store-rate">-->
            <!--<span :class="evaluateStoreVo.desEvalArrow">商品<em class="score">{{evaluateStoreVo.storeDesEval}}</em><i></i><em>{{getEvalArrowText(evaluateStoreVo.desEvalArrow) }}</em></span>-->
            <!--<span :class="evaluateStoreVo.serviceEvalArrow">服务<em class="score">{{evaluateStoreVo.storeServiceEval }}</em><i></i><em>{{getEvalArrowText (evaluateStoreVo.serviceEvalArrow) }}</em></span>-->
            <!--<span :class="evaluateStoreVo.deliveryEvalArrow">物流<em class="score">{{evaluateStoreVo.storeDeliveryEval  }}</em><i></i><em>{{getEvalArrowText (evaluateStoreVo.deliveryEvalArrow) }}</em></span>-->
            <!--</div>-->
          </div>
        </div>
        <div class="store-describe">
				<span class="tabs">
					<div class="num">{{storeInfo.storeCollect}}</div>
					<div class="text" data-name="收藏人数">ပရိသတ္ဦးေရ</div>
					<div class="vertical-line"></div>
				</span>
          <span class="tabs">
					<div class="num">{{goodsCommonCount}}</div>
					<div class="text" data-name="全部商品">ပစၥည္းအေရတြက္</div>
					<div class="vertical-line"></div>
				</span>
          <span class="tabs">
					<div class="num">{{evaluateStoreVo.avgStoreEval}}</div>
					<div class="text" data-name="店铺评分">အမွတ္</div>
					<div class="vertical-line"></div>
				</span>
        </div>
      </a>
      <!--<div class="store-bottom">-->
      <!--<div class="call-store store-public">-->
      <!--<a href="javascript:;" @click="bindGoIm()"><i class="call"></i>联系商家</a>-->
      <!--</div>-->
      <!--<div class="store-goto store-public">-->
      <!--<a href="javascript:;" @click ="bindGoStoreInfo()"><i class="goto"></i>进入店铺</a>-->
      <!--</div>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
  //    var ApiUrl = "https://my.zegobird.com:11101/api";

  /**
   * 商品详情页中的店铺详情
   */
  var urlStore = ApiUrl + '/goods/store/info/' ;
  export default {
    //外部传入参数
    props: {
      storeInfo: {
        type:Object,
        required:true
      },
      goodsCommonCount:{
        type:Number ,
        required:true

      },
      evaluateStoreVo :{
        type:Object ,
        required:true
      }
    },
    /*
     * 自身数据,一定要一个function
     */
    data() {
      return {

      }
    },
    /**
     * 计算属性
     */
    computed: {},

    /**
     * 监听属性变动
     */
    watch: {

    },
    /**
     * 过滤器
     */
    filters: {

    },
    /**
     * 生命周期钩子
     */

    beforeCreate() {

    },
    created() {

    },

    beforeMount() {

    },
    mounted() {


    },
    updated() {



//            if (this.first && this.hasInfo) {
//
//                this.first =false
//                this.$emit('domupdated')
//            }
    },
    /**
     * 自定义方法
     */
    methods: {
      getEvalArrowText:function (value) {

        if(value == 'high'){
          return "ျမင့္"//高 低 平
        }else if(value == 'low'){
          return 'နိမ့္'
        }else{
          return 'ပံုမွန္'
        }
      },
      //点击去im
      bindGoIm:function(){

        this.$emit('goim',this.storeInfo.storeId , this.storeInfo.sellerId)
      },
      //点击去店铺详情
      bindGoStoreInfo:function () {

        this.$emit('gostoreinfo',this.storeInfo.storeId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-store-info/goods-store-info.vue